import { FeatureToggleClientService } from 'feature-toggle-client';
const ONBOARDING_SIDEBAR_VISIBILITY = 'onboarding-sidebar-visibility';
export class OnboardingFeatures {
    static async isOnboardingSidebarVisible() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(ONBOARDING_SIDEBAR_VISIBILITY, false);
    }
}
